import React from 'react';
import useModalDialog from '../hooks/useModalDialog';
import '../App.css';

export default function MenuOverlay({ open, onClose, currentRoute = '/' }) {
  const dialogRef = useModalDialog(open);
  const section = React.useMemo(() => {
    if (!currentRoute || currentRoute === '/' || currentRoute === '#/') return 'home';
    const [, first = 'home'] = currentRoute.split('/');
    return first || 'home';
  }, [currentRoute]);

  const linkState = (key) => ({
    className: key === section ? 'active' : undefined,
    'aria-current': key === section ? 'page' : undefined,
  });

  const handle = () => {
    onClose?.();
  };
  return (
    <dialog ref={dialogRef} id="site-menu" className="overlay" aria-label="Site menu"
      onCancel={(event) => { event.preventDefault(); onClose(); }}>
      <button className="overlay-close" onClick={onClose} aria-label="Close menu">×</button>
      <div className="overlay-inner">
        <nav className="overlay-nav">
          <a href="#/" onClick={handle} {...linkState('home')}>HOME</a>
          <a href="#/blog" onClick={handle} {...linkState('blog')}>BLOG</a>
          <a href="#/poetry" onClick={handle} {...linkState('poetry')}>POETRY</a>
          <a href="#/projects" onClick={handle} {...linkState('projects')}>PROJECTS</a>
          <a href="#/gallery" onClick={handle} {...linkState('gallery')}>GALLERY</a>
        </nav>
      </div>
    </dialog>
  );
}
